import { interpolate } from '../../global';
import { ILanguageResources, ITranslationModule } from '../../interfaces';

// Localization IDs
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.quotes.QuoteStateReasons.';
  public static readonly price = `${Id.prefix}price`;
  public static readonly deadline = `${Id.prefix}deadline`;
  public static readonly productNotSuitable = `${Id.prefix}productNotSuitable`;
  public static readonly competitorWin = `${Id.prefix}competitorWin`;
  public static readonly unresponsiveClient = `${Id.prefix}unresponsiveClient`;
  public static readonly indecisiveClient = `${Id.prefix}indecisiveClient`;
  public static readonly unhappyClient = `${Id.prefix}unhappyClient`;
  public static readonly difficultClient = `${Id.prefix}difficultClient`;
  public static readonly superceeded = `${Id.prefix}superceeded`;
  public static readonly other = `${Id.prefix}other`;
}

// Wrapper for localized access
export class LangQuoteStateReasons {
  private constructor() {}

  public static readonly reason = {
    price: () => interpolate(Id.price),
    deadline: () => interpolate(Id.deadline),
    productNotSuitable: () => interpolate(Id.productNotSuitable),
    competitorWin: () => interpolate(Id.competitorWin),
    unresponsiveClient: () => interpolate(Id.unresponsiveClient),
    indecisiveClient: () => interpolate(Id.indecisiveClient),
    unhappyClient: () => interpolate(Id.unhappyClient),
    difficultClient: () => interpolate(Id.difficultClient),
    superceeded: () => interpolate(Id.superceeded),
    other: () => interpolate(Id.other)
  };
}

// Registration module
export class QuoteStateReasonsModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.price, 'Price', 'Reason: Price');
    register.add(Id.deadline, 'Deadline', 'Reason: Deadline');
    register.add(Id.productNotSuitable, 'Product Not Suitable', 'Reason: Product Not Suitable');
    register.add(Id.competitorWin, 'Competitor Win', 'Reason: Competitor Win');
    register.add(Id.unresponsiveClient, 'Unresponsive Client', 'Reason: Unresponsive Client');
    register.add(Id.indecisiveClient, 'Indecisive Client', 'Reason: Indecisive Client');
    register.add(Id.unhappyClient, 'Unhappy Client', 'Reason: Unhappy Client');
    register.add(Id.difficultClient, 'Difficult Client', 'Reason: Difficult Client');
    register.add(Id.superceeded, 'Superseded', 'Reason: Superseded');
    register.add(Id.other, 'Other', 'Reason: Other');
  }
}
